import { Lookup } from '../lookup.interface';

/**
 * Program filter codes shared by the worker dashboard UI (filter options/labels)
 * and the case search backend (accepted codes when building Mongo match conditions).
 * Keep this as the single source of truth to avoid drift between UI and backend.
 */
export enum CaseProgramFilterCode {
  Adap = 'ADAP',
  StreamC = 'STREAM_C',
}

/**
 * Client region filter codes shared by the worker dashboard UI and the case search backend.
 */
export enum ClientRegionFilterCode {
  Metro = 'METRO',
  NonMetro = 'NON_METRO',
}

export const CaseProgramFilterOptions: Lookup[] = [
  { code: CaseProgramFilterCode.Adap, displayValue: 'ADAP' },
  { code: CaseProgramFilterCode.StreamC, displayValue: 'Stream C' },
];

export const ClientRegionFilterOptions: Lookup[] = [
  { code: ClientRegionFilterCode.Metro, displayValue: 'Metro' },
  { code: ClientRegionFilterCode.NonMetro, displayValue: 'Non-Metro' },
];
